/**bannerContent**/
<template>
  <div class="bannerContent" ref="bannerContent" v-html="bannerContentFn">

  </div>
</template>

<script>
  export default {
    name: 'bannerContent',
    computed: {
      bannerContentFn: function () {
        return window.bannerContent
      }
    },
    data () {
      return {}
    },
    methods: {},
    watch: {},
    mounted: function () {
      let url = window.location.origin
      let imgs = document.getElementsByTagName('img')
      for (let i = 0; i < imgs.length; i++) {
        imgs[i].src = imgs[i].src.replace((url + ''), window.configure.serverUrl) + '?time=' + new Date().valueOf()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .bannerContent {
    box-sizing: border-box;
    padding: 1rem;
    height: 100%;
    width: 100%;
    img {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// bannerContent.vue?dab7a19e